<template>
  <div>
    <div v-if="isLoading" class="chat-place-holder font-weight-bold">
      <b-spinner class="align-middle" ></b-spinner>
      <strong>{{ $t('Loading...') }}</strong>
    </div>
    <div v-else>
      <template v-if="!isThereDate">
        <div width="200" height="100" class="chat-place-holder text-uppercase font-weight-bold text-secondary">
          {{$t('Nothing to show')}}
        </div>
      </template>
      <template v-else>
        <slot></slot>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "NothingToShow",
  props: {
    isLoading: true,
    isThereDate: {
      type: Boolean,
    },
  }
}
</script>

<style scoped>
  .chat-place-holder{
    text-align: center;
    padding: 120px 0;
  }
</style>
